import { useEffect, useState } from 'react';
import { filterModuleMap } from 'components/filter/filters-next/filterModuleMap';
import { useFilterModulesStore } from 'components/filter/filters-next/filterModules';
import { FilterCacheModule } from 'components/filter/types';

const useRegisterStaticFilters = () => {
    const { register } = useFilterModulesStore();
    const [didInit, setDidInit] = useState(false);

    useEffect(() => {
        Object.entries(filterModuleMap).forEach(([_, module]) => {
            const filterKeyArr = Array.isArray(module.filterKey)
                ? module.filterKey
                : [module.filterKey];

            filterKeyArr.forEach(filterKey =>
                register({ ...(module as FilterCacheModule), filterKey }),
            );
        });
        setDidInit(true);
    }, [register]);

    return { didInit };
};

export { useRegisterStaticFilters };
